import { render, staticRenderFns } from "./CardDownloadEnvios.vue?vue&type=template&id=118001f6"
import script from "./CardDownloadEnvios.vue?vue&type=script&lang=js"
export * from "./CardDownloadEnvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118001f6')) {
      api.createRecord('118001f6', component.options)
    } else {
      api.reload('118001f6', component.options)
    }
    module.hot.accept("./CardDownloadEnvios.vue?vue&type=template&id=118001f6", function () {
      api.rerender('118001f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardDownloadEnvios.vue"
export default component.exports